<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">{{ `${salesInvoice.code}` }} - {{ $t("COMMON.LOGS") }}</h3>
    <log-list-table :filterSubject="salesInvoice" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "sales-invoice-view-logs",

  components: { LogListTable },

  props: ["salesInvoice"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
